// Path: ./src/app/pages/RolePage/useRoleTableColumns.tsx
// setTableColumn.tsx

import { GridRenderCellParams } from "@mui/x-data-grid";
import { messages } from "../../../locales/messages";
import { AllowedTableColumn } from "../../../utils/types/AllowTableTypes";
import { RenderEditButton } from "../../components/RenderEditButtonTable";
import { useTranslation } from "react-i18next";
import { GfRoleDto } from "@swagger/typescript-fetch-goflyer";
import { useNavigate } from "react-router-dom";
import { RenderDeleteButton } from "../../components/RenderDeleteButtonTable";
import { PermissionComponentWrapper } from "../../components/PermissionComponentWrapper";
import { routes } from "../../../utils/constant/navigationRoutes";

export const useRoleTableColumns = (
  handleOpenDelete: (value: GfRoleDto) => Promise<void>,
) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const values: AllowedTableColumn[] = ["updatedAt", "createdAt"];
  /**
   * Handles the click event to navigate to the store editing page with pre-filled data.
   *
   * @param value - The EditProps containing store details for editing.
   */
  const handleOnClickEdit = async (value: GfRoleDto) => {
    navigate(routes.role.editById(value?.id || ""));
  };

  const columns = [
    {
      field: "edit",
      width: 90,
      headerName: `${t(messages.Edit())}`,
      filterable: false,
      renderCell: (props: GridRenderCellParams) => {
        return (
          <PermissionComponentWrapper
            requiredPermission={["edit"]}
            requiredPermissionGroup={["role"]}
          >
            <RenderEditButton
              onClick={handleOnClickEdit}
              {...props}
            ></RenderEditButton>
          </PermissionComponentWrapper>
        );
      },
      sortable: false,
    },
    {
      field: "name",
      width: 200,
      headerName: `${t(messages["name"]())}`,
    },
    ...values.map((value) => {
      return {
        width: 200,
        field: value,
        headerName: `${t(messages[value]())}`,
        type: "dateTime",
        valueGetter: (val: GridRenderCellParams) => {
          return val && new Date(val?.row[value]);
        },
      };
    }),

    {
      field: "id",
      width: 300,
      headerName: `${t(messages["id"]())}`,
      filterable: false,
    },
    {
      field: "delete",
      headerName: " ",
      width: 90,
      filterable: false,
      renderCell: (props: GridRenderCellParams) => {
        return (
          <RenderDeleteButton
            onClick={handleOpenDelete}
            {...props}
          ></RenderDeleteButton>
        );
      },
      sortable: false,
    },
  ];

  return columns;
};
